import { defineStore } from "pinia"
import moment from "@/utils/moment"
import {useLocalStorage, useSessionStorage} from "@vueuse/core"
import {CalendarViews} from "@/enums/calendarViews"
import {ref, computed} from "vue"

export const useCalendarStore = defineStore("calendar", () => {
  const calendarStart = useSessionStorage('calendarStart', moment().startOf('day').toISOString())
  const calendarView = useLocalStorage('calendarView', 'month')
  const showCalendarSelect = ref(false)
  const selectedYear = computed(() => moment(calendarStart.value).year())
  const selectedMonth = computed(() => moment(calendarStart.value).month())
  const selectedWeek = computed(() => moment(calendarStart.value).week())
  const selectedDay = computed(() => moment(calendarStart.value).day())

  const setDate = (view: CalendarViews, date: moment.Moment|Date|string) => {
    switch (view) {
      case CalendarViews.YEAR:
        setYear(date)
        break
      case CalendarViews.MONTH:
        setMonth(date)
        break
      case CalendarViews.WEEK:
        setWeek(date)
        break
      case CalendarViews.DAY:
        setDay(date)
        break
    }
  }
  const setMonth = (date: moment.Moment|Date|string) => {
    calendarStart.value = moment(date).startOf('month').toISOString()
    calendarView.value = CalendarViews.MONTH
  }
  const setYear = (date: moment.Moment|Date|string) => {
    calendarStart.value = moment(date).startOf('year').toISOString()
    calendarView.value = CalendarViews.YEAR
  }
  const setWeek = (date: moment.Moment|Date|string) => {
    calendarStart.value = moment(date).toISOString()
    calendarView.value = CalendarViews.WEEK
  }
  const setDay = (date: moment.Moment|Date|string) => {
    calendarStart.value = moment(date).startOf('day').toISOString()
    calendarView.value = CalendarViews.DAY
  }

  return {
    calendarStart,
    calendarView,
    showCalendarSelect,
    selectedYear,
    selectedMonth,
    selectedWeek,
    selectedDay,
    setDate,
    setMonth,
    setYear,
    setWeek,
    setDay
  }
})

